import React from "react";
import { useParams } from "react-router";
import { BasePage } from "components/BasePage/BasePage";
import { Breadcrumb } from "components/common/Breadcrumbs";
import { useProjectDetails } from "pages/Details/hooks/useProjectDetails";
import { useTranslation } from "react-i18next";
import { ManualProvider, useManualContext } from "./context/ManualContext";
import { ChapterListV2 } from "./components/ChapterListV2";
import { ChapterEditorV2 } from "./components/ChapterEditorV2";
import { ManualBuilderHeader } from "./components/ManualBuilderHeader";

interface ManualBuilderSearchParams {
  projectId: string;
}

const ManualBuilderContent: React.FC = () => {
  const { t } = useTranslation();
  const { projectId } = useParams<ManualBuilderSearchParams>();
  const { state, saveManual } = useManualContext();
  const { project } = useProjectDetails(projectId);

  const breadcrumbItems: Breadcrumb[] = [
    { label: "projects", location: "/dashboard" },
    {
      label: project?.projectdata?.product_name || projectId,
      location: `/projects/${projectId}`,
    },
    {
      label: t("manual.screen.title"),
      location: `/projects/${projectId}/manual`,
    },
  ];

  return (
    <BasePage breadcrumbItems={breadcrumbItems} loading={state.isLoading}>
      <div className="py-4 max-h-full overflow-y-hidden">
        <ManualBuilderHeader
          onSave={saveManual}
          hasUnsavedChanges={state.hasUnsavedChanges}
          lastChangeTimestamp={state.lastChangeTimestamp}
        />
        <div
          className="flex gap-6 overflow-y-hidden"
          style={{ maxHeight: "75vh" }}
        >
          <ChapterListV2 />
          <ChapterEditorV2 />
        </div>
      </div>
    </BasePage>
  );
};

const ManualBuilderV2: React.FC = () => {
  const { projectId } = useParams<ManualBuilderSearchParams>();

  return (
    <ManualProvider projectId={projectId}>
      <ManualBuilderContent />
    </ManualProvider>
  );
};

export default ManualBuilderV2;
